<template>
  <span class="anticon">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.46997 2.80176C5.76283 2.50916 6.23769 2.50911 6.53052 2.80176C6.82311 3.09459 6.82309 3.56946 6.53052 3.8623L4.47778 5.91504H8.66724C9.26235 5.91504 9.63348 5.91381 9.95435 5.95605C12.0853 6.237 13.7625 7.91395 14.0432 10.0449C14.0855 10.3659 14.0842 10.7367 14.0842 11.332C14.0842 11.746 13.7481 12.0816 13.3342 12.082C12.92 12.082 12.5842 11.7462 12.5842 11.332C12.5842 10.6891 12.5821 10.4401 12.5559 10.2412C12.3639 8.78298 11.2162 7.63554 9.75806 7.44336C9.5592 7.41718 9.30992 7.41504 8.66724 7.41504H4.47778L6.53052 9.46875C6.82311 9.76158 6.82309 10.2365 6.53052 10.5293C6.23767 10.8218 5.76277 10.8219 5.46997 10.5293L2.13696 7.19531C1.84423 6.90241 1.84412 6.4276 2.13696 6.13477L5.46997 2.80176Z"
        :fill="disabled ? 'rgba(0, 0, 0, 0.25)' : '#262626'" fill-opacity="0.88" />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
};
</script>
